import Vue from 'vue'
import VueRouter from 'vue-router'
import WorkOrder from '../views/WorkOrder.vue'
import Error from '../views/Error.vue'
import ApplicationError from '../views/Error2.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/:requestID',
    name: 'Service Request',
    component: WorkOrder
  },
  {
    path: '/error',
    name: 'Error',
    component: Error
  },
  {
    path: '/error',
    name: 'ApplicationError',
    component: ApplicationError
  },
  { 
    path: "*", 
    name: "Not Found",
    component: Error }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  document.title = to.name
  next()
})
export default router
